import React, { Component } from "react";
import "../common/preDamageSvgPartTable.css";

const allOtherPartImages = [
  { id: 1, name: "svg_Hood" },
  { id: 2, name: "svg_LeftFrontFender" },
  { id: 3, name: "svg_RightFrontFender" },
  { id: 4, name: "svg_LeftFrontDoor" },
  { id: 5, name: "svg_RightFrontDoor" },
  { id: 6, name: "svg_LeftBackDoor" },
  { id: 7, name: "svg_RightBackDoor" },
  { id: 8, name: "svg_LeftBackFender" },
  { id: 9, name: "svg_RightBackFender" },
  { id: 10, name: "svg_Trunk" },
  { id: 11, name: "svg_TrunkCover" },
  { id: 12, name: "svg_Roof" },
  { id: 13, name: "svg_LeftRoofFrame" },
  { id: 14, name: "svg_RightRoofFrame" },
  { id: 15, name: "svg_SideFenderTurnSignalRepeaterLampL" },
  { id: 16, name: "svg_FenderTrimPlateFL" },
  { id: 17, name: "svg_DecorStickerOfRoofFrameL" },
  { id: 18, name: "svg_SideViewMirrorL" },
  { id: 19, name: "svg_SideMirrorRepeaterLampL" },
  { id: 20, name: "svg_OuterUpperDoorWindowTrim_Crom_FL" },
  { id: 21, name: "svg_UprightOuterDoorCover_PlateFL" },
  { id: 22, name: "svg_OuterLowerDoorWindowSlotSeal_Crom_FL" },
  { id: 23, name: "svg_SideWindowFL" },
  { id: 24, name: "svg_DoorHandleFL" },
  { id: 25, name: "svg_Rocker_RunningPanelFL_DecorStrip" },
  { id: 26, name: "svg_UprightOuterDoorCover_PlateFirstOneBL" },
  { id: 27, name: "svg_OuterUpperDoorWindowTrim_Crom_BL" },
  { id: 28, name: "svg_UprightOuterDoorCover_PlateSecondOneBL" },
  { id: 29, name: "svg_OuterLowerDoorWindowSlotSeal_Crom_BL" },
  { id: 30, name: "svg_SideWindowBL" },
  { id: 31, name: "svg_DoorHandleBL" },
  { id: 32, name: "svg_Rocker_RunningPanelBL_DecorStrip" },
  { id: 33, name: "svg_QuarterWindowBL" },
  { id: 34, name: "svg_QuarterWindowTrim_Crom_BL" },
  { id: 35, name: "svg_FuelTankDoor" },
  { id: 36, name: "svg_FenderTrimPlateBL" },
  { id: 37, name: "svg_TailLightOuterL" },
  { id: 38, name: "svg_RearWindshieldDecorTrimL" },
  { id: 39, name: "svg_FogLightL" },
  { id: 40, name: "svg_FogLightR" },
  { id: 41, name: "svg_HeadlightL" },
  { id: 42, name: "svg_HeadlightR" },
  { id: 43, name: "svg_RadiatorGrille" },
  { id: 44, name: "svg_HoodEmblem" },
  { id: 45, name: "svg_CoverForPlenumChamberL" },
  { id: 46, name: "svg_CoverForPlenumChamberR" },
  { id: 47, name: "svg_WindshieldWiperL_ArmCap" },
  { id: 48, name: "svg_WindshieldWiperR_ArmCap" },
  { id: 49, name: "svg_Windshield" },
  { id: 50, name: "svg_WindshieldDecorTrimL" },
  { id: 51, name: "svg_WindshieldDecorTrimR" },
  { id: 52, name: "svg_RoofDripMoldingL" },
  { id: 53, name: "svg_RoofDripMoldingR" },
  { id: 54, name: "svg_SunRoof" },
  { id: 55, name: "svg_RoofRailL" },
  { id: 56, name: "svg_RoofRailR" },
  { id: 57, name: "svg_Antenna" },
  { id: 58, name: "svg_TrunckCover_Spoiler" },
  { id: 59, name: "svg_HighMountStopLight" },
  { id: 60, name: "svg_RearWindshield" },
  { id: 61, name: "svg_WiperForRearWindshield_ArmCap" },
  { id: 62, name: "svg_TrunkEmblem" },
  { id: 63, name: "svg_Emblem" },
  { id: 64, name: "svg_TailLightInnerL" },
  { id: 65, name: "svg_TailLightInnerR" },
  { id: 66, name: "svg_SideFenderTurnSignalRepeaterLampR" },
  { id: 67, name: "svg_FenderTrimPlateFR" },
  { id: 68, name: "svg_DecorStickerOfRoofFrameR" },
  { id: 69, name: "svg_SideViewMirrorR" },
  { id: 70, name: "svg_SideMirrorRepeaterLampR" },
  { id: 71, name: "svg_OuterUpperDoorWindowTrim_Crom_FR" },
  { id: 72, name: "svg_UprightOuterDoorCover_PlateFR" },
  { id: 73, name: "svg_OuterLowerDoorWindowSlotSeal_Crom_FR" },
  { id: 74, name: "svg_SideWindowFR" },
  { id: 75, name: "svg_DoorHandleFR" },
  { id: 76, name: "svg_Rocker_RunningPanelFR_DecorStrip" },
  { id: 77, name: "svg_UprightOuterDoorCover_PlateFirstOneBR" },
  { id: 78, name: "svg_OuterUpperDoorWindowTrim_Crom_BR" },
  { id: 79, name: "svg_UprightOuterDoorCover_PlateSecondOneBR" },
  { id: 80, name: "svg_OuterLowerDoorWindowSlotSeal_Crom_BR" },
  { id: 81, name: "svg_SideWindowBR" },
  { id: 82, name: "svg_DoorHandleBR" },
  { id: 83, name: "svg_Rocker_RunningPanelBR_DecorStrip" },
  { id: 84, name: "svg_QuarterWindowBR" },
  { id: 85, name: "svg_QuarterWindowTrim_Crom_BR" },
  { id: 86, name: "svg_FenderTrimPlateBR" },
  { id: 87, name: "svg_TailLightOuterR" },
  { id: 88, name: "svg_RearWindshieldDecorTrimR" },
  { id: 89, name: "svg_FrontBumper" },
  { id: 90, name: "svg_LeftFrontTyre" },
  { id: 91, name: "svg_LeftBackTyre" },
  { id: 92, name: "svg_RightFrontTyre" },
  { id: 93, name: "svg_RightBackTyre" },
  { id: 94, name: "svg_BackBumper" }

];
export default class PredamageSvgPartTable extends Component {
  render() {
    const { extraImages,lang } = this.props;
    const sortName = extraImages.map((images) => {
      return images.part;
    });

    const filteredParts = allOtherPartImages.filter((part) =>
      sortName.includes(part.name)
    );

    const firstTableIndexedParts = filteredParts.filter((_, i) => i % 2 === 0);
    const secondTableIndexedParts = filteredParts.filter((_, i) => i % 2 !== 0);
    return (
      <>
        <div className="predamage_table_wrapper">
          <div className="container-fluid p-0">
            <div className="row p-0">
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th className="text-left sr_row">
                          <p>Sr. No</p>
                        </th>
                        <th className="text-left part_name_row">
                          <p>{lang("Damage Description")}</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {firstTableIndexedParts &&
                        firstTableIndexedParts.map((partName, i) => {
                          const splitName = partName.name.split("svg_")[1];
                          return (
                            <tr key={i}>
                              <td class="text-left">
                                <p>{partName.id}</p>
                              </td>
                              <td class="text-left">
                                <p>{lang(splitName)}</p>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
              {
                secondTableIndexedParts && secondTableIndexedParts.length>0 &&
                (
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th className="text-left sr_row">
                              <p>Sr. No</p>
                            </th>
                            <th className="text-left part_name_row">
                            <p>{lang("Damage Description")}</p>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                        {secondTableIndexedParts &&
                            secondTableIndexedParts.map((partName, i) => {
                              const splitName = partName.name.split("svg_")[1];
                              return (
                                <tr key={i}>
                                  <td class="text-left">
                                    <p>{partName.id}</p>
                                  </td>
                                  <td class="text-left">
                                    <p>{lang(splitName)}</p>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )
              }
             
            </div>
          </div>
        </div>
      </>
    );
  }
}
